import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
  postSocialLogin,
} from "../../../helpers/fakebackend_helper";
import { loginAPI } from "../../../helpers/api.ts";

const fireBaseBackend = getFirebaseBackend();

function* loginUser({ payload: { user, history } }) {
  try {
    console.log('🔐 Login saga started with user:', { email: user.email });
    
    const response = yield call(loginAPI, {
      email: user.email,
      password: user.password,
    });
    
    console.log('✅ Login saga response received:', response);
    
    // Check if response has the expected structure
    if (response && response.token && response.userDetails) {
      // Store the token and user details in localStorage
      localStorage.setItem("user", JSON.stringify(response.userDetails));
      localStorage.setItem("token", response.token);
      
      console.log('✅ User data stored in localStorage');

      // Dispatch login success action
      yield put(loginSuccess(response.userDetails));

      console.log('✅ Navigating to dashboard');
      // Redirect user to dashboard
      history("/dashboard");
    } else {
      console.error('❌ Invalid response structure:', response);
      // Handle unexpected response structure
      yield put(apiError("Invalid response from server. Please try again."));
    }
  } catch (error) {
    console.error("❌ Login saga error:", error);
    
    // Handle different types of errors
    let errorMessage = "Login failed. Please try again.";
    
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      const { status, data } = error.response;
      
      console.error('❌ Server error response:', { status, data });
      
      switch (status) {
        case 400:
          errorMessage = data?.message || "Invalid email or password.";
          break;
        case 403:
          errorMessage = "This account has been disabled. Please contact an admin.";
          break;
        case 404:
          errorMessage = "Account not found. Please register first.";
          break;
        case 500:
          errorMessage = "Server error. Please try again later.";
          break;
        default:
          errorMessage = data?.message || data?.error || errorMessage;
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.error('❌ No response received:', error.request);
      errorMessage = "Unable to connect to the server. Please check your internet connection.";
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('❌ Request setup error:', error.message);
      errorMessage = error.message || errorMessage;
    }
    
    // Dispatch API error action
    yield put(apiError(errorMessage));
  }
}

function* logoutUser() {
  try {
    console.log('🚪 Logout started');
    
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    
    console.log('✅ User data cleared from localStorage');
    
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout);
      yield put(logoutUserSuccess(LOGOUT_USER, response));
    } else {
      yield put(logoutUserSuccess(LOGOUT_USER, true));
    }
    
    console.log('✅ Logout completed');
  } catch (error) {
    console.error("❌ Logout error:", error);
    yield put(apiError(LOGOUT_USER, error));
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  try {
    console.log('🔐 Social login started with type:', type);
    
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      const response = yield call(fireBaseBackend.socialLoginUser, data, type);
      localStorage.setItem("user", JSON.stringify(response));
      yield put(loginSuccess(response));
    } else {
      const response = yield call(postSocialLogin, data);
      localStorage.setItem("user", JSON.stringify(response));
      yield put(loginSuccess(response));
    }
    
    console.log('✅ Social login successful');
    history("/dashboard");
  } catch (error) {
    console.error("❌ Social login error:", error);
    yield put(apiError(error.message || "Social login failed"));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;